export const supportUs = `{
  page(id: "cG9zdDoxMjU=") {
    content
  }
}`;
